import { useQuery, QueryObserverOptions } from 'react-query';
import axiosClient from '@lib/utils/axiosClient';
import { ParamsWithId, ResourceKeys } from '../types';

async function fetchEntityById<EntityName extends string, Entity>(
  entity: EntityName,
  id: ParamsWithId['id'],
  params: Omit<ParamsWithId, 'id'>,
) {
  const response = await axiosClient.get<Entity>(`/${entity}/${id}`, { params });
  return response.data;
}

export function useEntityById<Entity>(
  keys: ResourceKeys['entity'],
  params: ParamsWithId,
  options?: QueryObserverOptions<Entity>,
) {
  const { id, ...restOfParams } = params;
  const entityKeys = keys(params);
  const [entityName] = entityKeys;
  return useQuery<Entity>(entityKeys, () => fetchEntityById(entityName, id, restOfParams), options);
}
